<style lang="scss" scoped>
    .table {
        width: 100%;
        border-spacing: 0px 10px;
        &:before {
            display: none !important;
        }
    }
    /deep/ .fp-choose .ivu-radio-wrapper{
        border-radius: 4px 4px 4px 4px !important;
    }
    /deep/ .fp-choose .ivu-radio-wrapper-checked{
        background: #2d8cf0 !important;
        color: #fff !important;
    }
</style>
<template>
    <div>
        <div class="overHidden">
            <span class="fLeft font16">量程：<span class="colorPrimary">{{val}}</span></span>
            <div class="displayIB fRight">
                <span>刷新时间: {{lodeTime}}</span>
                <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
            </div>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr class="textC">
                <th v-for="(tab,$index) in list" :key="$index" class="textC">
                    <span class="ivu-table-cell">{{tab.pointName}}({{tab.unit}})</span>
                </th>
            </tr>
            <tr class="textC">
                <th v-for="(tab,$index) in list" :key="$index" class="textC">
                    <span class="ivu-table-cell">{{tab.value}}</span>
                </th>
            </tr>
        </table>
        <div class="textRight m-t-10">
            <span class="fLeft lh32 m-r-30 font16">水位监测</span>
            <RadioGroup v-model="type" type="button" class="fp-choose">
                <Radio label="chart" class="m-r-10">图表</Radio>
                <Radio label="table">数据</Radio>
            </RadioGroup>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x" v-show="type == 'chart'"></line-chart>
        <private-table height="200" @sizeChange="sizeChange" class="m-t-20 m-b-40" :columnsList="tableColumns1" :dataTable="dataTable"
                       @getPageData="getPageData" v-show="type == 'table'" pageHide="true" :height="200"></private-table>
        <div class="m-t-20">
            <span class="font16">极值统计</span>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr  v-for="val in loadValue">
                <th>
                    <span class="ivu-table-cell">最大{{val.name}}：{{val.maxValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间：{{val.maxTime}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">最小{{val.name}}：{{val.minValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间：{{val.minTime}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
    import privateTable from '../wit-electric-monitor/private-table.vue';
    // 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'fp-water',
        props: {
            id: ''
        },
        data() {
            return {
                loginData: {},
                type: 'chart',
                lineData: {
                    x: [],
                    y: [],
                },
                loadValue: [],
                lodeTime: '',
                list: [],
                val: '',
                tableColumns1: [],
                page: {
                    totalCount: 0,
                    pageSize: 10,
                    currentPage: 1
                },
                dataTable: {},
                li: [],
            };
        },
        mounted() {
            this.getList();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
            //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            refresh() {
                this.lodeTime = getDate(new Date().getTime(), 'year');
                this.getTable();
            },
            getList() {
                this.refresh();
                this.getTable();
                this.getChart();
                this.getDetail();
                this.getData();
            },
            sizeChange(val) {
                this.page.pageSize = val;
                this.getData();
            },//每页条数
            getPageData(val) {
                this.page.currentPage = val;
                this.getData();
            },//分页页数
            getChart() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'sw'
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arrX = [], arrY = {}, index = 0;
                            for (let item in res.data.data) {
                                let obj = res.data.data[item];
                                for (let y = 0; y < obj.length; y++) {
                                    if (index === 0) arrX.push(obj[y]['time'].substring(11,19));
                                    if (arrY[item] && arrY[item].length) {
                                        arrY[item].push(obj[y]['value'])
                                    } else {
                                        arrY[item] = [obj[y]['value']];
                                    }
                                }
                                if (arrX.length) index = 1;
                            }
                            let translate = {
                                '今日': arrY.today,
                                '昨日': arrY.yesterday,
                            }
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = translate;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getData() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/data/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'sw',
                            date:this.day
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            res.data.data.map((value,index) => {
                                if(index == 0){
                                    this.tableColumns1 = [];
                                    for (let i in value) {
                                        this.tableColumns1.push({
                                            title: i,
                                            key: i
                                        })
                                    }
                                }
                            })
                            this.li = res.data.data;
                            this.page.totalCount = res.data.totalCount;
                            this.dataTable = {
                                list: this.li,
                                page: this.page,
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'sw',
                            pageSize: this.page.pageSize,
                            currentPage: this.page.currentPage,
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            if(res.data.data.length > 0){
                                this.val = res.data.data[0].ranges;
                                this.list = res.data.data;
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getDetail() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/loadValue/${this.id}`;
                    let _this = this
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'sw'
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            this.loadValue = res.data.data;
                            this.loadValue.forEach(function(value) {
                                value.maxTime != '~' ? value.maxTime = getDate(parseInt(value.maxTime), 'year') : value.maxTime = '~';
                                value.minTime != '~' ? value.minTime = getDate(parseInt(value.minTime), 'year') : value.minTime = '~';
                            });
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
        }
        ,
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart,
            privateTable
        }
    }
    ;
</script>


// WEBPACK FOOTER //
// src/components/fp/fp-water.vue